import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import { Table } from '../../../dpe-usco'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import leftArrow from '../../../dpe-usco/asset/icons/left_arrow.svg'
import { getProgram, deleteProgram } from '../../../services/apiHelper'
import AddEditProgramForm from '../../../components/ModalForms/AddEditProgramForm'
import error_outline from '../../../assets/icons/error_outline.svg'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'

export const AddCompanyProgramsView = () => {
  const [showModal, setShowModal] = useState(false)
  const [isEmptyStatus, setIsEmptyStatus] = useState(false)
  const [data, setData] = useState([])
  const [isProgramEdit, setIsProgramEdit] = useState(false)
  const [programId, setProgramId] = useState(false)
  const [programName, setProgramName] = useState('')
  const [deleteId, setDeleteId] = useState('')
  const [loading, setLoading] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [deleteError, setDeleteError] = useState(false)
  const [isProgramHaveProdPlan, setIsProgramHaveProdPlan] = useState(false)
  let history = useHistory()
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortByKey, setSortByKey] = useState()

  const reset = () => {
    setProgramId('')
    setProgramName('')
    setDeleteId('')
    setLoading(false)
    setIsDelete(false)
    setDeleteError('')
    setIsProgramHaveProdPlan(false)
  }

  const addProgramHandler = () => {
    setIsProgramEdit(false)
    setShowModal(true)
  }

  const editProgramHandler = programId => {
    setShowModal(true)
    setIsProgramEdit(true)
    setProgramId(programId)
    const programData = data.filter(progData => progData.program_id === programId)
    setProgramName(programData[0].program_name)
  }

  const deleteProgramHandler = programId => {
    setIsDelete(true)
    setDeleteId(programId)
  }

  const deleteHandler = async () => {
    setDeleteError('loading')

    await deleteProgram(deleteId).then(
      response => {
        if (response?.status === 200) {
          setIsDelete(false)
          window.location.reload()
        } else if (response?.data.errors) {
          if (response.data.errors[0].key_path === 'program_id') {
            setIsProgramHaveProdPlan(true)
            setIsDelete(false)
          } else {
            setDeleteError('error')
            window.location.reload()
          }
        } else {
          setDeleteError('error')
        }
      })
  }

  useEffect(() => {
    setLoading(true)
    getProgram()
      .then(res => {
        if (res?.data.programs.length) {
          const getActiveOnly = res.data.programs.filter(item => item.is_active)
          setData(getActiveOnly)
        } else {
          setIsEmptyStatus(true)
        }
        setLoading(false)
      })
  }, [])

  const customSort = (data, dataKey, sortBy) => {
    if (data?.length && dataKey) {
      setSortOrder(sortBy)
      setSortByKey(dataKey)
      let newTableData = []
      if (dataKey === 'created' && sortBy === 'asc') {
        newTableData = [...data].sort(function (a, b) {
          return new Date(a.created) - new Date(b.created)
        })
      } else if (dataKey === 'created') {
        newTableData = [...data].sort(function (a, b) {
          return new Date(b.created) - new Date(a.created)
        })
      } else if (sortBy === 'asc') {
        newTableData = [...data].sort((a, b) => {
          return a[dataKey]?.toLowerCase() > b[dataKey]?.toLowerCase() ? 1 : -1
        })
      } else {
        newTableData = [...data].sort((a, b) => {
          return a[dataKey]?.toLowerCase() > b[dataKey]?.toLowerCase() ? -1 : 1
        })
      }
      return newTableData
    }
    return data || []
  }

  const buttons = (
    <div className='df'>
      <div>
        <Button
          type="outline"
          text='Add Program'
          customClassName="mr20 syn-button-success"
          clickHandler={addProgramHandler}
        />
      </div>
    </div>)

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setSortOrder('asc')
      setSortByKey(dataKey)
      setData(customSort(data, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setSortOrder('desc')
      setSortByKey(dataKey)
      setData(customSort(data, dataKey, 'desc'))
    }

    return (
      <div key={value} className='cell df aic'>
        <span>{value}</span>
        {value !== 'Action' && <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />}
      </div>
    )
  }

  const formatDate = dateString => {
    const date = new Date(dateString)
    const month = date.toLocaleString('en-US', { month: 'long' })
    const day = date.getDate()
    const year = date.getFullYear()
    let suffix = 'th'
    if (day === 1 || day === 21 || day === 31) {
      suffix = 'st'
    } else if (day === 2 || day === 22) {
      suffix = 'nd'
    } else if (day === 3 || day === 23) {
      suffix = 'rd'
    }
    const formattedDay = `${day}${suffix}`
    const time = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    })
    return `${month} ${formattedDay} ${year}, ${time.toLowerCase()}`
  }

  const structure = {
    headers: [
      {
        value: 'Program Name',
        format: () => headerCell('Program Name', 'program_name')
      },
      {
        value: 'Created Date',
        format: () => headerCell('Created Date', 'created')
      },
      {
        value: 'Action',
        format: () => headerCell('Action')
      }
    ],
    dataKeys: [
      'program_name',
      'created',
      'program_id'
    ],
    rowFormat: {
      program_id: {
        format: value => {
          return (
            <div>
              <Button type="outline" text='Edit' customClassName="mb0 mr20" clickHandler={() => editProgramHandler(value)} />
              <Button type="error" text='Delete' customClassName="mb0 mr20" clickHandler={() => deleteProgramHandler(value)} />
            </div>
          )
        }
      },
      created: {
        format: value => {
          return <div>{formatDate(value)}</div>
        }
      }
    }
  }

  return (
    <>
      {showModal &&
        <div data-testid="adminModal">
          <Modal
            autoHeight
            show={showModal}
            handleClose={reset}
          >
            <AddEditProgramForm handleClose={() => setShowModal(false)} isProgramEdit={isProgramEdit} programId={programId} programName={programName} />
          </Modal>
        </div>
      }

      {isDelete &&
        <Modal
          autoHeight
          show={isDelete}
          handleClose={reset}
          customModalClassName='z1000'
        >
          <div className='w500 tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
            <div className='bb1-s-lightgray df jcsb'>
              <div className='df ml15 mt15 mb15'>
                <div className='fw600 ml10'>
                  Delete Program?
                </div>
              </div>
            </div>
            {(deleteError === 'loading') ?
              <>
                <div className='p25 h80 df aic jcfs wowb'>
                  <span className='wspn fz15'>
                    Delete in progress. Please wait.
                  </span>
                </div>
                <div className='bt1-s-lightgray df aic jcfe'>
                  <div className='mt8 mb8 mr8'>
                    <Button disabled customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset} />
                  </div>
                </div>
              </> :
              (deleteError === 'error') ?
                <>
                  <div className='p25 h80 df aic jcfs wowb'>
                    <span className='wspn fz15'>
                      Something went wrong. Please contact your admin.
                    </span>
                  </div>
                  <div className='bt1-s-lightgray df aic jcfe'>
                    <div className='mt8 mb8 mr8'>
                      <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset} />
                    </div>
                  </div>
                </>
                :
                <>
                  <div className='p25 h80 df aic jcfs wowb'>
                    <span className='wspn fz15 tac'>
                      Are you sure you want to permanently delete this program?
                    </span>
                  </div>
                  <div className='bt1-s-lightgray df aic jcfe'>
                    <div className='mt8 mb8 mr8'>
                      <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset} />
                      <Button customClassName='miw70' type='error' text='Delete'
                        onClick={deleteHandler} />
                    </div>
                  </div>
                </>
            }
          </div>
        </Modal>
      }
      {isProgramHaveProdPlan &&
        <Modal
          autoHeight
          show={isProgramHaveProdPlan}
          handleClose={reset}
          customModalClassName='z1000'
        >
          <div className='w500 tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
            <div className='bb1-s-lightgray df jcsb' >
              <div className='df ml15 mt15 mb15'>
                <img src={error_outline} alt='error icon'></img>
                <div className='p15'>
                  {'This program is linked with the production plan, so it can\'t be deleted.'}
                </div>
              </div>
            </div>
            <div className='bt1-s-lightgray df aic jcfe'>
              <div className='mt8 mb8 mr8'>
                <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={reset} />
              </div>
            </div>
          </div>
        </Modal>
      }


      {loading ? <div className="df aic jcc h175"> <div className='loader h80 w80' /> </div> :
        <>
          <button
            className='df aic jcsb l20'
            style={{
              background: 'none',
              color: 'inherit',
              border: 'none',
              padding: '0 0 0 25px',
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit'
            }}
            onClick={() => history.goBack()}
          >
            <img src={leftArrow} alt='return arrow' className='curp mr10' />
            <span className='fz17 c-neutral-500 fs'>Back</span>
          </button>
          <DetailView button={buttons} title={'Programs'} disableBack={true}>
            <>
              <Table structure={structure} data={data} statusComponent={isEmptyStatus ? <div>No programs.</div> : null} />
            </>
          </DetailView>
        </>
      }
    </>
  )
}

export default AddCompanyProgramsView